import { Component, inject, Inject, OnInit } from '@angular/core';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

// Translator.
import { TranslateService, TranslatePipe } from '@ngx-translate/core';

// Components.
import { ImageViewerComponent } from '../image-viewer/image-viewer.component';

// Services.
import { SIESPServicesService } from '../../services/siespServices.service';
import { ReportsService } from '../../services/reports.service';

// Material.
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule }  from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-result-details',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    TranslatePipe,
    MatIconModule,
    CommonModule,
    NgxSpinnerModule,
    MatDividerModule,
    MatTooltipModule
  ],
  templateUrl: './result-details.component.html',
  styleUrl: './result-details.component.scss'
})
export class ResultDetailsComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ResultDetailsComponent>,
    public translate: TranslateService,
    private spinner: NgxSpinnerService,
    private api: SIESPServicesService,
    private rapi: ReportsService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){}
  private _snackBar = inject(MatSnackBar);

  result: any = null;

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.spinner.show();
    this.api.GetMVXServiceResult(this.data.id).subscribe({
      next: (response) => {
        this.spinner.hide();
        if (response.success === 1) {
          this.result = response.data;
        } else {
          this.openSnackBar(response.message);
        }
      },
      error: (error) => {
        this.spinner.hide();

        const statusCode = error.status;
        const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";
  
        this.openSnackBar(`Error ${statusCode}: ${errorMessage}`);
        console.error(`Error ${statusCode}`, error);
      },
    });
  }

  openImageGallery(evidence: any) {
    this.dialog.open(ImageViewerComponent, {
      
      data: {
        images: evidence.evidenceImages[0]
      }
    });
  }

  downloadReport(): void {
    this.spinner.show();
    this.rapi.DownloadResult(this.data.id).subscribe({
      next: (response) => {
        this.spinner.hide();
        if (response.success === 1) {
          const blob = this.b64toBlob(response.data.documentoB64, response.data.tipoDoc);
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.download = 'MVXResultReport.pdf';
          link.click();

          window.URL.revokeObjectURL(url);
        } else {
          this.openSnackBar(response.message);
        }
      },
      error: (error) => {
        this.spinner.hide();

        const statusCode = error.status;
        const errorMessage = error.error?.message || "An error occurred trying to connect to web services.";
  
        this.openSnackBar(`Error ${statusCode}: ${errorMessage}`);
        console.error(`Error ${statusCode}`, error);
      }
    });
  }

  b64toBlob(b64Data: string, contentType: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  closeModal() {
    this.dialogRef.close();
  }

  openSnackBar(Message: string) {
    this._snackBar.open(Message, "Dismiss", { duration: 5000 });
  }
}
